import React from 'react'

export default function CustomCheckbox2({
    checked = false,
    onChange,
    disabled = false,
}) {
    return (
        <>
            <div className="customCheckbox-new">
                <label class="customblocknew">
                    <input type="checkbox"
                    
                        checked={checked}
                        onChange={onChange}
                        disabled={disabled}
                    />
                    <div class="checkmark"></div>
                </label>
            </div>
        </>
    )
}
